import { GoogleMap, Marker } from '@react-google-maps/api'
import React, { useEffect } from 'react'
import useGoogleMapsLoader from './useGoogleMapsLoader'
import { defaultMapCenter } from '../../Utils/map'

export type MapQueryProps = {
  locations: {
    latitude: number
    longitude: number
    postalCode: string
    street: string
    city: string
    name?: string
  }[]
  apiKey: string
  focusedAddress?: React.Dispatch<React.SetStateAction<{
    street: string;
    city: string;
    postalCode: string;
  } | null>>
  height?: number
  width?: number
}

const Map: React.FC<MapQueryProps> = ({
  locations,
  apiKey,
  focusedAddress = undefined,
  height = 396,
  width = undefined,
}) => {
  const defaultZoom = 5
  const [zoom, setZoom] = React.useState(defaultZoom)
  const [center, setCenter] = React.useState(defaultMapCenter)

  useEffect(() => {
    if (locations.length === 1) {
      setCenter({
        lat: locations[0].latitude,
        lng: locations[0].longitude,
      })
      setZoom(16)
    }
  }, [])

  useEffect(() => {
    if (focusedAddress) {
      setCenter({
        lat: focusedAddress.latitude,
        lng: focusedAddress.longitude,
      })
      setZoom(16)
    }
  }, [focusedAddress])

  const isLoaded = useGoogleMapsLoader(apiKey)

  if (!isLoaded) {
    return null
  }

  return (
    <GoogleMap
      mapContainerStyle={{
        height: `${height}px`,
        width: width ? `${width}px` : '',
        borderRadius: '0.75rem',
      }}
      center={center}
      zoom={zoom}
      options={{
        disableDefaultUI: true,
        gestureHandling: 'greedy', // DOC https://tomchentw.github.io/react-google-maps/#googlemap
        streetViewControl: false,
      }}
    >
      {locations.map((location, index) => (
        <Marker
          key={index.toLocaleString()}
          position={{ lat: location.latitude, lng: location.longitude }}
          title={
            `${location.name ? location.name : ''} ${location.street} ${location.postalCode
            } ${location.city}` || ''
          }
          onClick={() => {
            setCenter({
              lat: location.latitude,
              lng: location.longitude,
            })
            setZoom(16)
          }}
        />
      ))}
    </GoogleMap>
  )
}

export default Map
